/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AccountRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type DeleteAccountError = {
  errorType: ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF.ErrorType;
  localizedErrorMessage: string;
  englishErrorMessage: string;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DeleteAccountRequest = { accountId: number };

export type DeleteAccountResponse = {};

export namespace ComHubspotUnifiedAccountApiModelsAccountDeleteaccountDeleteAccountErrorIF {
  export type ErrorType =
    | 'UNKNOWN'
    | 'UNAUTHORIZED_USER_ACTION'
    | 'APP_NOT_FOUND'
    | unhandledEnumCase;
}

export type ListAccountsForAppError = {
  errorType: ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF.ErrorType;
  localizedErrorMessage: string;
  englishErrorMessage: string;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ListAccountsForAppRequest = { appId: number };

export type ListAccountsForAppResponse = { accounts: Default<AccountInfo[]> };

export namespace ComHubspotUnifiedAccountApiModelsAccountListaccountsforappListAccountsForAppErrorIF {
  export type ErrorType = 'UNKNOWN' | unhandledEnumCase;
}

export type UninstallAppError = {
  errorType: ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF.ErrorType;
  localizedErrorMessage: string;
  englishErrorMessage: string;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UninstallAppRequest = { appId: number };

export type UninstallAppResponse = {
  deletedAccountsCount: number;
  deletedAccountIds: Default<number[]>;
};

export namespace ComHubspotUnifiedAccountApiModelsAccountUninstallappUninstallAppErrorIF {
  export type ErrorType =
    | 'UNKNOWN'
    | 'APP_NOT_FOUND'
    | 'UNAUTHORIZED_USER_ACTION'
    | unhandledEnumCase;
}

export type VerifyAccountError = {
  errorType: ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF.ErrorType;
  localizedErrorMessage: string;
  englishErrorMessage: string;
  extraDetailsMessage?: string;
  upstreamError?: UAuthUpstreamError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type VerifyAccountRequest = { accountId: number };

export type VerifyAccountResponse = { accountStatus: AccountHealthStatus };

export namespace ComHubspotUnifiedAccountApiModelsAccountVerifyaccountVerifyAccountErrorIF {
  export type ErrorType =
    | 'UNKNOWN'
    | 'ACCOUNT_NOT_FOUND'
    | 'AUTH_FAILED'
    | 'UPSTREAM_FAILED'
    | 'UPSTREAM_RATE_LIMITED'
    | 'SECRET_NOT_FOUND'
    | unhandledEnumCase;
}

export type AccountHealthStatus =
  | 'OK'
  | 'UNAVAILABLE'
  | 'DISCONNECTED'
  | unhandledEnumCase;

export type AccountInfo = {
  id: number;
  displayName: string;
  status: AccountHealthStatus;
};

export type UAuthUpstreamError = {
  upstreamRequestId?: string;
  upstreamErrorMessageInterpretation?: string;
};

export type DeleteAccountRequestType = Requestify<DeleteAccountRequest>;
export type DeleteAccountResponseType = DeleteAccountResponse;
export type DeleteAccountErrorType = DeleteAccountError & HubspotMetadata;
export const deleteAccountRpc: ChirpAvroRpcDetails<
  DeleteAccountRequestType,
  DeleteAccountResponseType,
  DeleteAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: '9HaU0AlvAmHfLB0x2FUSFN2vsMeep-F1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListAccountsForAppRequestType =
  Requestify<ListAccountsForAppRequest>;
export type ListAccountsForAppResponseType = ListAccountsForAppResponse;
export type ListAccountsForAppErrorType = ListAccountsForAppError &
  HubspotMetadata;
export const listAccountsForAppRpc: ChirpAvroRpcDetails<
  ListAccountsForAppRequestType,
  ListAccountsForAppResponseType,
  ListAccountsForAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'listAccountsForApp',
  auth: 'app',
  fingerprint: 'xJVkD3SziOG0-WNDWCNTBmwqhOka-7dG',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallAppRequestType = Requestify<UninstallAppRequest>;
export type UninstallAppResponseType = UninstallAppResponse;
export type UninstallAppErrorType = UninstallAppError & HubspotMetadata;
export const uninstallAppRpc: ChirpAvroRpcDetails<
  UninstallAppRequestType,
  UninstallAppResponseType,
  UninstallAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'uninstallApp',
  auth: 'app',
  fingerprint: 'ajdF8-3Y4IR5G50dc_33gZp4Kfp53o1H',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type VerifyAccountRequestType = Requestify<VerifyAccountRequest>;
export type VerifyAccountResponseType = VerifyAccountResponse;
export type VerifyAccountErrorType = VerifyAccountError & HubspotMetadata;
export const verifyAccountRpc: ChirpAvroRpcDetails<
  VerifyAccountRequestType,
  VerifyAccountResponseType,
  VerifyAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AccountRpc',
  rpcName: 'verifyAccount',
  auth: 'app',
  fingerprint: 'J5COPZAUAOQeO4ZaOIO67WuA8GmEYGuH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
